import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "container-xl" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_3 = {
    class: "card",
    "data-cy": "scheduledgroupstitle"
};
const _hoisted_4 = { class: "card-body" };
const _hoisted_5 = { class: "card-title" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("h6", { class: "card-subtitle mb-2 text-muted" }, "waiting to be set to active", -1);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_8 = {
    class: "card",
    "data-cy": "activegroupstitle"
};
const _hoisted_9 = { class: "card-body" };
const _hoisted_10 = { class: "card-title" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_12 = {
    class: "card",
    "data-cy": "finishedgroupstitle"
};
const _hoisted_13 = { class: "card-body" };
const _hoisted_14 = { class: "card-title" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_16 = {
    class: "card",
    "data-cy": "archivedgroupstitle"
};
const _hoisted_17 = { class: "card-body" };
const _hoisted_18 = { class: "card-title" };
import TeamsTable from '@/components/Teams/TeamsTable';
import { computed } from 'vue';
import { GroupNewButton, GroupRow } from '@/components/Groups';
import { GroupState } from '@/types/group';
import { useAllGroups } from '@/compositions/useGroups';
import { useArchivedTeams } from '@/compositions/useTeams';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { waitingGroups, activeGroups, finishedGroups } = useAllGroups();
        const { archivedTeams } = useArchivedTeams();
        const waitingCount = computed(() => Object.values(waitingGroups.value).length);
        const activeCount = computed(() => Object.values(activeGroups.value).length);
        const finishedCount = computed(() => Object.values(finishedGroups.value).length);
        const archivedCount = computed(() => Object.values(archivedTeams.value).length);
        const componentKey = computed(() => {
            return `${waitingCount.value}-${activeCount.value}-${finishedCount.value}-${archivedCount.value}`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h5", _hoisted_5, "Scheduled Groups (" + _toDisplayString(_unref(waitingCount)) + ")", 1),
                        _hoisted_6,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(waitingGroups)), ([groupId, group]) => {
                            return (_openBlock(), _createBlock(_unref(GroupRow), {
                                group: group,
                                groupId: groupId,
                                actions: ['delete', 'start', 'edit', 'qr'],
                                key: groupId + '_' + _unref(componentKey),
                                "data-cy": "scheduledgroups"
                            }, null, 8, ["group", "groupId"]));
                        }), 128))
                    ])
                ]),
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h5", _hoisted_10, "Active Groups (" + _toDisplayString(_unref(activeCount)) + ")", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(activeGroups)), ([groupId, group]) => {
                            return (_openBlock(), _createBlock(_unref(GroupRow), {
                                group: group,
                                groupId: groupId,
                                actions: ['stop', 'edit', 'info', 'qr', 'scan'],
                                key: groupId + '_' + _unref(componentKey),
                                "data-cy": "activegroups"
                            }, null, 8, ["group", "groupId"]));
                        }), 128))
                    ])
                ]),
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("h5", _hoisted_14, "Finished Groups (" + _toDisplayString(_unref(finishedCount)) + ")", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(finishedGroups)), ([groupId, group]) => {
                            return (_openBlock(), _createBlock(_unref(GroupRow), {
                                group: group,
                                groupId: groupId,
                                key: groupId + '_' + _unref(componentKey),
                                actions: ['info', 'edit', 'archive'],
                                "data-cy": "finishedgroups"
                            }, null, 8, ["group", "groupId"]));
                        }), 128))
                    ])
                ]),
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("h5", _hoisted_18, "Archived Teams (" + _toDisplayString(_unref(archivedCount)) + ")", 1),
                        _createVNode(_unref(TeamsTable), {
                            teamtype: _unref(GroupState).Archived,
                            actions: ['edit', 'delete', 'info'],
                            "data-cy": "archivedteams"
                        }, null, 8, ["teamtype"])
                    ])
                ]),
                _createVNode(_unref(GroupNewButton))
            ]));
        };
    }
});
